export abstract class HandledError extends Error {
  protected constructor(name: string, message: string) {
    super(message)
    this.name = name
  }

  abstract get userFriendlyDisplay(): { title: string; message: string }
  abstract get fingerprint(): string[] | undefined

  abstract isSentryIgnored(): boolean
}
